import React, { memo } from "react";
import { Message } from "react-message-context";
import PropTypes from "prop-types";
import { UNIDENTIFIED } from "../../utils/enums";

const SensitiveInfo = memo(({ customerType }) => {
  const isIdentifiedCustomer = customerType !== UNIDENTIFIED;

  return (
    <p id="ROF-sensitiveInfo" className="rof-sensitiveInfo">
      <Message
        id={`feedback.sensitiveInfo.${
          isIdentifiedCustomer ? "identifiedCustomer" : "unidentifiedCustomer"
        }`}
      />
    </p>
  );
});

SensitiveInfo.propTypes = {
  customerType: PropTypes.string.isRequired,
};

export default SensitiveInfo;
